document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.hil-section');

  sections.forEach(function (section) {
    var items = section.querySelectorAll('.hil-item');
    var previewImg = section.querySelector('.hil-preview__img');
    if (!previewImg) return;

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var src = item.getAttribute('data-image');
        if (!src) return;
        previewImg.src = src;
        previewImg.classList.add('is-active');
      });

      item.addEventListener('mouseleave', function () {
        previewImg.classList.remove('is-active');
      });
    });

    section.addEventListener('mouseleave', function () {
      previewImg.classList.remove('is-active');
    });
  });
});
